// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-filter {
  background-color: transparent;
}
.slide-transition {
  transition: transform 0.5s ease; /* Adjust the duration and easing as needed */
}

.fixed-card-height {
  height: 140px;
}

.col-lg-6.pb-2 {
  padding-bottom: 0.5rem !important; /* Reduce bottom white space */
}

.content-container-height{
    td{
        height: 68px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/subscription.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B,EAAE,6CAA6C;AAChF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC,EAAE,8BAA8B;AACnE;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".table-filter {\n  background-color: transparent;\n}\n.slide-transition {\n  transition: transform 0.5s ease; /* Adjust the duration and easing as needed */\n}\n\n.fixed-card-height {\n  height: 140px;\n}\n\n.col-lg-6.pb-2 {\n  padding-bottom: 0.5rem !important; /* Reduce bottom white space */\n}\n\n.content-container-height{\n    td{\n        height: 68px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
